import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {ConversionEngineSettings} from '../../../../../model/conversion-engine-settings.model';

@Component({
  selector: 'auto-private-offers',
  templateUrl: './private-offers.component.html',
  styleUrls: ['./private-offers.component.scss']
})
export class PrivateOffersComponent implements OnInit, OnChanges {
  @Input() data: ConversionEngineSettings | null = null;
  @Output() formGroupInitialized = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      includePrivateOffersInExternalAdvertising: [false, Validators.required],
      unlockPrivateOffersEnabled: [false, Validators.required]
    });
    this.formGroupInitialized.emit(this.form);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasIncoming = !!this.data && !!this.form;
    if (hasIncoming) {
      this.form.patchValue({
        includePrivateOffersInExternalAdvertising: !!this.data.includePrivateOffersInExternalAdvertising,
        unlockPrivateOffersEnabled: !!this.data.unlockPrivateOffersEnabled
      }, { emitEvent: false });
      this.form.markAsPristine();
    }
  }
}
